import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "./PermissionContext";

const ProtectedRoute = ({ children, requiredPermission = null }) => {
  const { hasPermission, hasAnyPermission, loading } = usePermissions();
  let userData = null;
  try {
    const userDataStr = localStorage.getItem("user");
    userData = userDataStr ? JSON.parse(userDataStr) : null;
  } catch (e) {
    userData = null; // fallback if parsing fails
  }
  // If not logged in, redirect to login
  if (!userData) {
    return <Navigate to="/login" replace />;
  }

  // If permissions are still loading, show loading
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If no specific permission required, just check if user has any permissions
  if (!requiredPermission) {
    if (!hasAnyPermission()) {
      return <Navigate to="/no-permission" replace />;
    }
    return children;
  }

  // Check for specific permission
  if (!hasPermission(requiredPermission)) {
    return <Navigate to="/no-permission" replace />;
  }

  return children;
};

export default ProtectedRoute;
